<template>
  <img
    v-if="url"
    :src="url"
    :alt="name"
    :width="size"
    :height="size"
    class="alg-img"
    loading="lazy"
  />
  <span v-else class="alg-ph" :style="phStyle">{{ initial }}</span>
</template>

<script>
import { store } from '@/store'
import { resolveAllergen, isRealPhoto } from '@/data'

export default {
  name: 'AllergenImage',
  props: {
    id: { type: Number, required: true },
    size: { type: [Number, String], default: 24 }
  },
  computed: {
    url() {
      const fromMap = store.alergenosMap[this.id]
      const candidate = store.iconCache[this.id] || (fromMap && fromMap.icono_url) || ''
      return isRealPhoto(candidate) ? candidate : ''
    },
    name() {
      const cat = store.alergenoIndex[this.id]
      const fromMap = store.alergenosMap[this.id]
      return (cat && cat.nombre) ||
        (fromMap && fromMap.nombre) ||
        resolveAllergen(this.id, store.locale, store.alergenosMap).name
    },
    initial() {
      return (this.name || '?').trim().charAt(0).toUpperCase()
    },
    phStyle() {
      const s = `${this.size}px`
      return { width: s, height: s }
    }
  }
}
</script>

<style scoped>
.alg-img { object-fit: contain; display: block; }
.alg-ph {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--sand-100);
  color: var(--ink-500);
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 0.8rem;
}
</style>
